import React, { useEffect, useState, useContext } from "react";
import { toast } from "react-toastify";
import { WarehouseContext } from "../../../Utility/UserContext";
import {
  getItemPurchaseReturns,
  postGeneralData,
  UpdatePaymentComplete
} from "../../../Utility/Api";
import { Pagination } from "../../Common/Functions";
import { getFormattedCurrentDate2, onReqCreatePayment } from "../../../Utility/function";

const rolesPerPage = 10;

const ItemPurchaseReturnList = () => {
  const { showLoader, hideLoader, shopItem, UserItem } = useContext(WarehouseContext);
  const [returnList, setReturnList] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);

  const [showModal, setShowModal] = useState(false);
  const [detailData, setDetailData] = useState(null);

  const [pamentsModel, setpamentsModel] = useState(false);
  const [Paymentvalue, setPaymentvalue] = useState(null);
  const [payAmount, setPayAmount] = useState(0);

  const fetchReturnList = async () => {
    try {
      showLoader();
      const res = await getItemPurchaseReturns();
      if (res?.data?.data) {
        setReturnList(res.data.data);
        setTotalPages(Math.ceil(res.data.data.length / rolesPerPage));
      }
    } catch (error) {
      console.error(error);
      toast.error("Failed to fetch return list");
    } finally {
      hideLoader();
    }
  };

  useEffect(() => {
    fetchReturnList();
  }, [shopItem]);

  const handleView = (item) => {
    try {
      const parsedItems = JSON.parse(item.invoice_number || "[]");
      setDetailData({
        return_id: item.unique_id,
        date: item.create_date?.split("T")[0],
        items: parsedItems.map((entry) => ({
          product_name: entry.product_name || `Item #${entry.item_id}`,
          qty: entry.returnqty || entry.qty || 1,
          amount: parseFloat(entry.amount || entry.price || 0).toFixed(2),
        }))
      });
      setShowModal(true);
    } catch (e) {
      toast.error("Invalid return data format");
    }
  };

  const handleOpenPayment = (item) => {
    setPaymentvalue(item);
    setPayAmount(parseFloat(item.remaining || 0));
    setpamentsModel(true);
  };

  const submitPayment = async () => {
    try {
      showLoader();
      const remainingAmount = parseFloat(Paymentvalue.remaining || 0) - payAmount;

      const paydata = {
        orderID: Paymentvalue.unique_id,
        date: getFormattedCurrentDate2(),
        amount: "0",
        total_amount: Paymentvalue.amount,
        cash: payAmount,
        credit: remainingAmount > 0 ? remainingAmount : 0,
        card: 0,
        type: 6, // Purchase Return Payment type
        mop: "1",
        complete: remainingAmount <= 0 ? "1" : "0",
      };

      if (remainingAmount > 0) {
        paydata.mop = "1,2";
      }

      await onReqCreatePayment(paydata);

      // Log General Ledger bank deposit from purchase return
      const bankPayload = {
        type: "2",
        ref_id: Paymentvalue.unique_id,
        remarks: "Bank Deposit from Item Purchase Refund",
        date: getFormattedCurrentDate2(),
        created_by: UserItem?.user_id,
        shop_id: shopItem?.id || shopItem?.shop_id || "0",
        amount: parseFloat(payAmount),
        is_debit: "1", // Debit increases cash/bank asset
      };
      await postGeneralData(bankPayload);

      if (remainingAmount <= 0) {
        const paymentCompleted = {
          type: "12",
          shop_id: shopItem?.id || shopItem?.shop_id || "0",
          ref_id: Paymentvalue.unique_id,
        };
        await UpdatePaymentComplete(paymentCompleted);
      }

      toast.success("Refund received successfully");
      setpamentsModel(false);
      fetchReturnList();
    } catch (error) {
      toast.error("Error processing payment");
    } finally {
      hideLoader();
    }
  };

  return (
    <div className="page-wrappers">
      <div className="page-content">
        
        {/* Header */}
        <div className="mb-4 d-flex justify-content-between align-items-center bg-white p-3 rounded-2xl border border-slate-100 shadow-sm">
          <div className="text-start">
            <h3 className="mb-1 fw-bold text-slate-800 tracking-tight" style={{ fontSize: "24px" }}>Item Purchase Return List</h3>
            <p className="text-sm text-slate-500 mb-0 font-medium">Record and manage vendor item returns and refunds</p>
          </div>
        </div>

        {/* Table */}
        <div className="card border-0 shadow-sm rounded-2xl">
          <div className="card-body p-4">
            <div className="table-responsive">
              <table className="table table-hover table-align-middle text-center mb-4" style={{ fontFamily: "Poppins" }}>
                <thead className="table-light">
                  <tr>
                    <th>S.No</th>
                    <th>Return ID</th>
                    <th>Date</th>
                    <th>Amount (INR)</th>
                    <th>Status</th>
                    <th>Action</th>
                  </tr>
                </thead>
                <tbody>
                  {returnList.length > 0 ? (
                    returnList.slice((currentPage - 1) * rolesPerPage, currentPage * rolesPerPage).map((item, index) => {
                      const isRefunded = item.status === "0" || parseFloat(item.remaining || 0) === 0;
                      return (
                        <tr key={item.id} className="align-middle border-bottom border-slate-100">
                          <td className="text-sm font-semibold text-slate-700 py-3">{(currentPage - 1) * rolesPerPage + index + 1}</td>
                          <td className="text-sm font-semibold text-slate-700">{item.unique_id}</td>
                          <td className="text-sm text-slate-600">{new Date(item.create_date).toLocaleDateString()}</td>
                          <td className="text-sm font-semibold text-slate-700">₹{parseFloat(item.amount).toFixed(2)}</td>
                          <td>
                            <span className={`badge px-2.5 py-1 text-xs font-bold uppercase rounded-full`} style={{
                              backgroundColor: isRefunded ? "#ecfdf5" : "#fff7ed",
                              color: isRefunded ? "#10b981" : "#f97316"
                            }}>
                              {isRefunded ? "Refunded" : "Credit Pending"}
                            </span>
                          </td>
                          <td>
                            <div className="d-flex align-items-center gap-2 justify-content-center">
                              <button className="btn btn-primary btn-sm px-3" onClick={() => handleView(item)}>View</button>
                              {!isRefunded && (
                                <button className="btn btn-warning btn-sm px-3" onClick={() => handleOpenPayment(item)}>Receive</button>
                              )}
                            </div>
                          </td>
                        </tr>
                      );
                    })
                  ) : (
                    <tr>
                      <td colSpan="6" className="text-center text-slate-400 py-4">No returns found</td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>

            <Pagination
              currentPage={currentPage}
              totalPages={totalPages}
              onPageChange={(page) => setCurrentPage(page)}
            />
          </div>
        </div>

        {/* View Details Modal */}
        {showModal && detailData && (
          <div className="modal fade show" style={{ display: "block" }} tabIndex="-1">
            <div className="modal-dialog modal-md">
              <div className="modal-content">
                <div className="modal-header">
                  <h5 className="modal-title">Return Details</h5>
                  <button type="button" className="btn-close" onClick={() => setShowModal(false)}></button>
                </div>
                <div className="modal-body">
                  <p><strong>Return ID:</strong> {detailData.return_id}</p>
                  <p><strong>Date:</strong> {detailData.date}</p>
                  <hr />
                  <h6>Items Returned</h6>
                  <table className="table table-bordered text-center align-middle">
                    <thead className="table-light">
                      <tr>
                        <th>#</th>
                        <th>Item</th>
                        <th>Qty</th>
                        <th>Amount</th>
                      </tr>
                    </thead>
                    <tbody>
                      {detailData.items.map((it, idx) => (
                        <tr key={idx}>
                          <td>{idx + 1}</td>
                          <td>{it.product_name}</td>
                          <td>{it.qty}</td>
                          <td>₹{it.amount}</td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                  <div className="text-end">
                    <button type="button" className="btn btn-secondary" onClick={() => setShowModal(false)}>Close</button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        )}

        {/* Payment Modal */}
        {pamentsModel && Paymentvalue && (
          <div className="modal fade show" style={{ display: "block" }} tabIndex="-1">
            <div className="modal-dialog modal-dialog-centered">
              <div className="modal-content p-3" style={{ borderRadius: "12px" }}>
                <div className="modal-header border-0">
                  <h5 className="modal-title fw-bold">Receive Refund Payout</h5>
                  <button type="button" className="btn-close" onClick={() => setpamentsModel(false)}></button>
                </div>
                <div className="modal-body bg-light rounded p-3">
                  <p>Return ID: <strong>{Paymentvalue.unique_id}</strong></p>
                  <p>Total Refund Due: <strong className="text-success">₹{parseFloat(Paymentvalue.remaining || 0).toFixed(2)}</strong></p>
                  <hr />
                  <div className="d-flex justify-content-between align-items-center mb-2">
                    <span>Amount Received:</span>
                    <input
                      type="number"
                      className="form-control w-50 text-end"
                      value={payAmount}
                      max={parseFloat(Paymentvalue.remaining)}
                      onChange={(e) => setPayAmount(parseFloat(e.target.value) || 0)}
                    />
                  </div>
                </div>
                <div className="modal-footer border-0">
                  <button type="button" className="btn btn-secondary" onClick={() => setpamentsModel(false)}>Cancel</button>
                  <button type="button" className="btn btn-success" onClick={submitPayment} disabled={payAmount <= 0}>Receive Now</button>
                </div>
              </div>
            </div>
          </div>
        )}

      </div>
    </div>
  );
};

export default ItemPurchaseReturnList;
